__turbopack_context__.v({
  "column": "entries-module-scss-module__IThw0q__column",
  "empty": "entries-module-scss-module__IThw0q__empty",
  "groups": "entries-module-scss-module__IThw0q__groups",
  "sectionHeading": "entries-module-scss-module__IThw0q__sectionHeading",
  "sidebar": "entries-module-scss-module__IThw0q__sidebar",
});
